<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big">
            {{ 'UPLOADER_MODAL_CUSTOMIZATION_PREMIUM_REQUIRED_TITLE' | translate }}
        </div>
    </div>
    <div class="body">
        <div class="section">
            <p>
                {{ 'UPLOADER_MODAL_CUSTOMIZATION_PREMIUM_REQUIRED_EXPLANATION' | translate }}
                <a class="pricing-link" id="modal-customization-forbidden-link-pricing" target="_blank"
                    href="{{ 'UPLOADER_MODAL_CUSTOMIZATION_PREMIUM_REQUIRED_EXPLANATION_RED_LINK_FROMSMASH_URL' | translate }}">
                    {{ 'UPLOADER_MODAL_CUSTOMIZATION_PREMIUM_REQUIRED_EXPLANATION_RED_LINK_FROMSMASH_LABEL' | translate
                    }}
                </a>
            </p>
        </div>
    </div>
    <div class="footer">
        <button class="btn-new red" (click)="signIn()">{{
            'UPLOADER_MODAL_CUSTOMIZATION_PREMIUM_REQUIRED_BUTTON_LABEL_SIGNIN' | translate
            }}</button>
    </div>
</div>